export default __webpack_public_path__ + "static/media/Density.b6011dd4.svg";